// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"da0fb5ae","728":"524363ad","890":"bd63cbf0","998":"84382ecd"}[chunkId] + ".chunk.js";
};